import { useEffect, useState } from "react"

// Returns `value` delayed by `delay` ms. Used to debounce the inbox search box
// (300ms) before it hits the query param, so typing doesn't fire a request per
// keystroke.
export default function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(t)
  }, [value, delay])
  return debounced
}
